import React, { useEffect, useRef, useState } from 'react';
import { Form, InputNumber } from 'antd';
import { HeartOutlined, InfoCircleOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if (formPlugin.formData.type !== "COMPLEX") {
                if (props.remove) {
                    props.remove()
                }
                return null
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props

            let rules = [{ required: data.required || false, message: t`Ce champ est obligatoire` }]

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            const listFieldProps = listField ? listField : null
            const finalName = "[FREE_AMOUNT]_" + data.fieldKey

            const isAbo=formPlugin.formData?.paiementType==="MONTHLY"
            let aboAdonAfter=""
            if(isAbo) {
                aboAdonAfter=t` /Mois`
            }

            return (
                <div ref={(ref) => containerRef.current = ref}>
                    <Form.Item
                        {...listFieldProps}
                        label={<Trans>{(data.label || t`Question`)} :</Trans>}
                        name={listField ? [listField.name, finalName].flat() : finalName}
                        rules={rules}
                        tooltip={tooltip}
                    >
                        <InputNumber
                            decimalSeparator={','}
                            min={0}
                            placeholder={data.placeholder}
                            addonAfter={formPlugin.getDeviseSymbol()+aboAdonAfter}
                            style={{ width: "100%" }}
                            onBlur={(e) => formPlugin.editorRef.forceUpdate()}
                        />
                    </Form.Item>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-free-amount' + namespace,
        title: t`Montant Libre`,
        description: t`Élément de formulaire utilisable.`,
        icon: <HeartOutlined />,
        iconColor: "#8E44AD",
        hideInMenu: formPlugin.formData.type !== "COMPLEX",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du Champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    placeholder: {
                        type: 'string',
                        uniforms: {
                            label: t`Sous-Étiquette`,
                            placeholder: t`Sous-Étiquette`,
                        }
                    },
                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                }
            },
        },
    }
}
